// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { deleteCartItem } from "./Apiservice";
// import { Link, useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import { GoTrash } from "react-icons/go";
// import WhatsAppChatWidget from "./WhatsAppChatWidget";
// import { FaExclamationTriangle } from "react-icons/fa";
// const Cart = () => {
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedItems, setSelectedItems] = useState([]);
//   const navigate = useNavigate();
//   const [availableStock, setAvailableStock] = useState({});
//   const [showConfirmButton, setShowConfirmButton] = useState({});
//   const [loadingUpdate, setLoadingUpdate] = useState({});

//   useEffect(() => {
//     window.scrollTo(0, 0); // Scroll to the top when the component mounts
//   }, []);

//   useEffect(() => {
//     const fetchCartDetails = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const userId = localStorage.getItem("userId");
//         let url = `https://vishushethra.com/api/api/cart-fetch/`;
//         let config = {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           // withCredentials: true // Uncomment if you need credentials
//         };

//         // If user is logged in, fetch their cart
//         if (userId) {
//           url = `https://vishushethra.com/api/api/cart-fetch/${userId}/`;
//         }

//         const response = await axios.get(url, config);

//         // Check if response has data
//         if (response.data && response.data.cart) {
//           setCartItems(response.data.cart);

//           const availableStockMap = {};
//           response.data.cart.forEach((item) => {
//             availableStockMap[item.cart_item_id] = item.quantity;
//           });

//           setAvailableStock(availableStockMap);
//         } else {
//           setCartItems([]);
//           setError("No cart items found.");
//         }
//       } catch (err) {
//         console.error("Error fetching cart:", err);
//         setError("Failed to load cart items. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCartDetails();
//   }, []);

//   const handleUpdateQuantity = (cartItemId, newQuantity) => {
//     if (newQuantity < 1) return;

//     const item = cartItems.find((item) => item.cart_item_id === cartItemId);

//     // Check if trying to increase quantity beyond available stock
//     if (newQuantity > item.stock_quantity) {
//       Swal.fire({
//         icon: "warning",
//         title: "Insufficient Stock",
//         text: `Only ${item.stock_quantity} items available in stock.`,
//       });
//       return;
//     }

//     // Update the cart item state with the new quantity
//     setCartItems((prevItems) =>
//       prevItems.map((item) =>
//         item.cart_item_id === cartItemId
//           ? { ...item, quantity: newQuantity }
//           : item
//       )
//     );

//     // Show the confirm button after quantity change
//     setShowConfirmButton((prev) => ({ ...prev, [cartItemId]: true }));
//   };

//   const handleConfirmUpdate = async (cartItemId, newQuantity) => {
//     setLoadingUpdate((prev) => ({ ...prev, [cartItemId]: true })); // Show loading

//     try {
//       await axios.patch(
//         `https://vishushethra.com/api/api/cart-update/${cartItemId}/`,
//         { quantity: newQuantity }
//       );

//       setCartItems((prevItems) =>
//         prevItems.map((item) =>
//           item.cart_item_id === cartItemId
//             ? { ...item, quantity: newQuantity }
//             : item
//         )
//       );

//       Swal.fire({
//         icon: "success",
//         title: "Updated",
//         text: "Quantity and price updated successfully!",
//         timer: 1500,
//         showConfirmButton: false,
//       }).then(() => {
//         // Reload the page when "OK" is clicked
//         window.location.reload();
//       });

//       // Hide the confirm button after success
//       setShowConfirmButton((prev) => ({ ...prev, [cartItemId]: false }));
//     } catch (error) {
//       console.error("Error updating quantity", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to update quantity.",
//       });
//     } finally {
//       setLoadingUpdate((prev) => ({ ...prev, [cartItemId]: false })); // Reset loading
//     }
//   };

//   const handleRemoveItem = async (cartItemId) => {
//     try {
//       await deleteCartItem(cartItemId);
//       setCartItems((prevItems) =>
//         prevItems.filter((item) => item.cart_item_id !== cartItemId)
//       );
//       Swal.fire({
//         icon: "success",
//         title: "Removed",
//         text: "Item removed successfully from cart!",
//         timer: 1500,
//         showConfirmButton: false,
//       });
//     } catch (error) {
//       console.error("Error removing item from cart", error);
//       setError("Failed to remove item from cart.");
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to remove item from cart.",
//       });
//     }
//   };

//   const handleSelectItem = (cartItemId) => {
//     setSelectedItems((prevSelected) => {
//       const item = cartItems.find((item) => item.cart_item_id === cartItemId);

//       if (item) {
//         // Don't allow selection if item is sold out
//         if (item.sold_out) {
//           Swal.fire({
//             icon: "warning",
//             title: "Item Unavailable",
//             text: "This product is currently sold out.",
//           });
//           return prevSelected;
//         }

//         // Don't allow selection if quantity or actual_quantity exceeds stock
//         if (
//           item.quantity > item.stock_quantity ||
//           item.actual_quantity > item.stock_quantity
//         ) {
//           Swal.fire({
//             icon: "warning",
//             title: "Insufficient Stock",
//             text: `Only ${item.stock_quantity} items available in stock. Please reduce quantity.`,
//           });
//           return prevSelected;
//         }

//         return prevSelected.includes(cartItemId)
//           ? prevSelected.filter((id) => id !== cartItemId)
//           : [...prevSelected, cartItemId];
//       }
//       return prevSelected;
//     });
//   };

//   const handleOrderClick = () => {
//     // First validate stock quantities
//     const itemsWithInsufficientStock = cartItems
//       .filter((item) => selectedItems.includes(item.cart_item_id))
//       .filter((item) => {
//         // Check if quantity exceeds stock OR actual_quantity exceeds stock
//         return (
//           item.quantity > item.stock_quantity ||
//           item.actual_quantity > item.stock_quantity
//         );
//       });

//     if (itemsWithInsufficientStock.length > 0) {
//       const productNames = itemsWithInsufficientStock
//         .map((item) => `${item.product_name} (Stock: ${item.stock_quantity})`)
//         .join(", ");
//       Swal.fire({
//         icon: "error",
//         title: "Insufficient Stock",
//         html: `The following items don't have enough stock:<br><strong>${productNames}</strong><br><br>Please adjust your quantities or remove these items.`,
//       });
//       return;
//     }

//     const itemsToOrder = cartItems
//       .filter((item) => selectedItems.includes(item.cart_item_id))
//       .map((item) => ({
//         ...item,
//         updated_price: parseFloat(item.item_price * item.quantity).toFixed(2),
//       }));

//     if (itemsToOrder.length > 0) {
//       Swal.fire({
//         icon: "success",
//         title: "Proceeding to Order",
//         text: "Redirecting to order page...",
//         timer: 1500,
//         showConfirmButton: false,
//       }).then(() => {
//         navigate("/Payment", { state: { items: itemsToOrder } });
//       });
//     } else {
//       Swal.fire({
//         icon: "error",
//         title: "No items selected",
//         text: "Please select at least one item to order.",
//       });
//     }
//   };

//   return (
//     <div>
//       <div className="banner-section  ">
//         <img
//           src="./assets/img/bannerbreadcrumbs.jpg"
//           alt="Banner"
//           className="img-fluid banner-img"
//         />

//         <div className="breadcrumb-container ">
//           <h2> Shopping Cart</h2>
//           <nav aria-label="breadcrumb">
//             <ol className="breadcrumb mb-0">
//               <li className="breadcrumb-item">
//                 <Link to="/">Home</Link>
//               </li>

//               <li className="breadcrumb-item active" aria-current="page">
//                 Shopping Cart
//               </li>
//             </ol>
//           </nav>
//         </div>
//       </div>

//       <h2 className="text-center my-5">Shopping Cart</h2>

//       <div className="shopping_cart_area mt-5">
//         <div className="container">
//           <form action="#">
//             <div className="cart_page_inner mb-60">
//               <div className="row">
//                 <div className="col-12">
//                   <div className="cart_page_tabel">
//                     {loading ? (
//                       <p>Loading...</p>
//                     ) : error ? (
//                       <p>{error}</p>
//                     ) : (
//                       <table>
//                         <thead>
//                           <tr>
//                             <th>Product</th>
//                             <th className="text-center">Information</th>
//                             <th className="text-center">Quantity</th>
//                             <th className="text-center">Total</th>
//                             <th className="text-center">Select to order</th>
//                             <th>Remove</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {cartItems.length > 0 ? (
//                             [...cartItems].reverse().map((item) => (
//                               <tr key={item.product_id} className="border-top">
//                                 <td>
//                                   <div className="cart_product_thumb">
//                                     <Link
//                                       to={`/Productdetail/${item.product_id}`}
//                                     >
//                                       <img
//                                         src={item.images[0]}
//                                         alt={item.product_name}
//                                       />
//                                     </Link>
//                                   </div>
//                                 </td>
//                                 <td className="cart-centermlist">
//                                   <div className="cart_product_text">
//                                     <h4>
//                                       <Link
//                                         to={`/Productdetail/${item.product_id}`}
//                                         style={{ color: "black" }}
//                                       >
//                                         {item.product_name}{" "}
//                                       </Link>
//                                     </h4>
//                                     {/* {item.sold_out ? (
//                                       <span className="sold-out-tag">
//                                         Sold Out
//                                       </span>
//                                     ) : (
//                                       item.offer_type === "bogo" && (
//                                         <span className="bogo-tag">
//                                           Buy {item.offer_details.buy_quantity}{" "}
//                                           Get {item.offer_details.get_quantity}{" "}
//                                           Offer
//                                         </span>
//                                       )
//                                     )} */}
//                                     {item.sold_out ? (
//                                       <span className="sold-out-tag">
//                                         Sold Out
//                                       </span>
//                                     ) : item.offer_type === "buy_x_get_y" ? (
//                                       <span className="bogo-tag">
//                                         Buy {item.buy_x} Get {item.get_y} Offer
//                                       </span>
//                                     ) : item.offer_type ===
//                                         "discount_percentage" &&
//                                       item.discount_percentage > 0 ? (
//                                       <span className="discount-tag">
//                                         {item.discount_percentage}% Off
//                                       </span>
//                                     ) : null}
//                                     {item.actual_quantity >
//                                       item.stock_quantity && (
//                                       <div className="stock-warning">
//                                         <FaExclamationTriangle />
//                                         Warning: Your selected quantity exceeds
//                                         available stock
//                                       </div>
//                                     )}
//                                     <ul>
//                                       <li>
//                                         {item.size && item.size !== "" ? (
//                                           <>
//                                             Size: <span>{item.size}</span>
//                                           </>
//                                         ) : null}
//                                       </li>
//                                       <li>
//                                         {item.option && item.option !== null ? (
//                                           <>
//                                             {JSON.parse(
//                                               item.option.replace(/'/g, '"')
//                                             ).map((option, index) => (
//                                               <div key={index}>
//                                                 {option.name &&
//                                                   option.value && (
//                                                     <>
//                                                       {option.name}:{" "}
//                                                       {option.value}
//                                                     </>
//                                                   )}
//                                               </div>
//                                             ))}
//                                           </>
//                                         ) : null}
//                                       </li>
//                                     </ul>
//                                   </div>
//                                 </td>
//                                 <td className="product_quantity mx-2 ">
//                                   <div className="cart_product_quantity d-flex align-items-center justify-content-center">
//                                     <button
//                                       className="btn btn-outline-secondary cart-border"
//                                       type="button"
//                                       onClick={() =>
//                                         handleUpdateQuantity(
//                                           item.cart_item_id,
//                                           item.quantity - 1
//                                         )
//                                       }
//                                       disabled={item.sold_out}
//                                     >
//                                       -
//                                     </button>
//                                     <input
//                                       className="text-center"
//                                       min="1"
//                                       value={item.quantity}
//                                       type="number"
//                                       readOnly
//                                       style={{
//                                         width: "50px",
//                                       }}
//                                       disabled={item.sold_out}
//                                     />

//                                     <button
//                                       className="btn btn-outline-secondary cart-borderplus"
//                                       type="button"
//                                       onClick={() =>
//                                         handleUpdateQuantity(
//                                           item.cart_item_id,
//                                           item.quantity + 1
//                                         )
//                                       }
//                                       disabled={
//                                         item.sold_out ||
//                                         item.quantity >= item.stock_quantity ||
//                                         item.actual_quantity >
//                                           item.stock_quantity
//                                       }
//                                     >
//                                       +
//                                     </button>

//                                     {showConfirmButton[item.cart_item_id] &&
//                                       !loadingUpdate[item.cart_item_id] && (
//                                         <button
//                                           className="btn btn-outline-success ml-2"
//                                           type="button"
//                                           onClick={() =>
//                                             handleConfirmUpdate(
//                                               item.cart_item_id,
//                                               item.quantity
//                                             )
//                                           }
//                                         >
//                                           Update
//                                         </button>
//                                       )}

//                                     {loadingUpdate[item.cart_item_id] && (
//                                       <span
//                                         className="spinner-border spinner-border-sm ml-2"
//                                         role="status"
//                                         aria-hidden="true"
//                                       ></span>
//                                     )}
//                                   </div>
//                                 </td>

//                                 <td>
//                                   <div className="cart_product_price">
//                                     {loadingUpdate[item.cart_item_id] ? (
//                                       <span>
//                                         <span
//                                           className="spinner-border spinner-border-sm"
//                                           role="status"
//                                           aria-hidden="true"
//                                         ></span>
//                                         <span
//                                           style={{
//                                             fontSize: "13px",
//                                             marginLeft: "5px",
//                                           }}
//                                         >
//                                           Updating...
//                                         </span>
//                                       </span>
//                                     ) : (
//                                       <span>
//                                         ₹
//                                         {parseFloat(
//                                           item.item_price
//                                         ).toLocaleString("en-IN", {
//                                           minimumFractionDigits: 2,
//                                         })}{" "}
//                                         <span style={{ fontSize: "13px" }}>
//                                           INR
//                                         </span>
//                                       </span>
//                                     )}
//                                   </div>
//                                 </td>

//                                 <td className="cart-center">
//                                   <div className="checkboxes__row">
//                                     <label className="checkbox style-h">
//                                       <input
//                                         type="checkbox"
//                                         checked={selectedItems.includes(
//                                           item.cart_item_id
//                                         )}
//                                         onChange={() =>
//                                           handleSelectItem(item.cart_item_id)
//                                         }
//                                       />
//                                       <div className="checkbox__checkmark"></div>
//                                       <div className="checkbox__body">
//                                         <span>Select to Order</span>
//                                       </div>
//                                     </label>
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <div className="cart_product_remove">
//                                     <button
//                                       className="btn btn-danger px-4"
//                                       type="button"
//                                       onClick={() =>
//                                         handleRemoveItem(item.cart_item_id)
//                                       }
//                                     >
//                                       <GoTrash
//                                         style={{
//                                           fontSize: "20px",
//                                           fontWeight: "900",
//                                         }}
//                                       />
//                                     </button>
//                                   </div>
//                                 </td>
//                               </tr>
//                             ))
//                           ) : (
//                             <tr>
//                               <td colSpan="7">Your cart is empty.</td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>
//                     )}
//                   </div>
//                   <div className="cart_page_mobiletabel">
//                     {loading ? (
//                       <p>Loading...</p>
//                     ) : error ? (
//                       <p>{error}</p>
//                     ) : (
//                       <div>
//                         {/* Mobile Responsive Design */}
//                         {cartItems.length > 0 ? (
//                           [...cartItems].reverse().map((item) => (
//                             <div
//                               key={item.product_id}
//                               className="cart_item_mobile"
//                             >
//                               <div className="cart_item_mobile_info">
//                                 <div className="cart_product_thumb">
//                                   <Link
//                                     to={`/Productdetail/${item.product_id}`}
//                                   >
//                                     <img
//                                       src={item.images[0]}
//                                       alt={item.product_name}
//                                     />
//                                   </Link>
//                                 </div>
//                                 <div>
//                                   <div className="cart_item_mobile_price">
//                                     <span>
//                                       ₹
//                                       {parseFloat(
//                                         item.item_price
//                                       ).toLocaleString("en-IN", {
//                                         minimumFractionDigits: 2,
//                                       })}{" "}
//                                       <span style={{ fontSize: "13px" }}>
//                                         INR
//                                       </span>
//                                     </span>
//                                   </div>
//                                   <h4>
//                                     {" "}
//                                     <Link
//                                       to={`/Productdetail/${item.product_id}`}
//                                       style={{ color: "black" }}
//                                     >
//                                       {item.product_name}
//                                     </Link>
//                                   </h4>
//                                   {/* {item.sold_out ? (
//                                     <span className="sold-out-tag">
//                                       Sold Out
//                                     </span>
//                                   ) : (
//                                     item.is_bogo && (
//                                       <span className="bogo-tag">
//                                         Buy 1 Get 1 Offer
//                                       </span>
//                                     )
//                                   )} */}
//                                   {/* {item.sold_out ? (
//                                     <span className="sold-out-tag">
//                                       Sold Out
//                                     </span>
//                                   ) : (
//                                     item.offer_type === "bogo" && (
//                                       <span className="bogo-tag">
//                                         Buy {item.offer_details.buy_quantity}{" "}
//                                         Get {item.offer_details.get_quantity}{" "}
//                                         Offer
//                                       </span>
//                                     )
//                                   )} */}
//                                   {item.sold_out ? (
//                                     <span className="sold-out-tag">
//                                       Sold Out
//                                     </span>
//                                   ) : item.offer_type === "buy_x_get_y" ? (
//                                     <span className="bogo-tag">
//                                       Buy {item.buy_x} Get {item.get_y} Offer
//                                     </span>
//                                   ) : item.offer_type ===
//                                       "discount_percentage" &&
//                                     item.discount_percentage > 0 ? (
//                                     <span className="discount-tag">
//                                       {item.discount_percentage}% Off
//                                     </span>
//                                   ) : null}
//                                   <ul style={{ paddingLeft: "0px" }}>
//                                     {item.size && item.size !== "" ? (
//                                       <>
//                                         Size: <span>{item.size}</span>
//                                       </>
//                                     ) : null}
//                                     <li style={{ paddingLeft: "0px" }}>
//                                       {item.option && item.option !== null ? (
//                                         <>
//                                           {JSON.parse(
//                                             item.option.replace(/'/g, '"')
//                                           ).map((option, index) => (
//                                             <div key={index}>
//                                               {option.name && option.value && (
//                                                 <>
//                                                   {option.name}: {option.value}
//                                                 </>
//                                               )}
//                                             </div>
//                                           ))}
//                                         </>
//                                       ) : null}
//                                     </li>
//                                   </ul>
//                                 </div>
//                                 <div>
//                                   <div className="cart_item_mobile_remove">
//                                     <button
//                                       className="btn btn-danger"
//                                       type="button"
//                                       onClick={() =>
//                                         handleRemoveItem(item.cart_item_id)
//                                       }
//                                     >
//                                       <GoTrash />
//                                     </button>
//                                   </div>
//                                 </div>
//                               </div>
//                               {item.actual_quantity > item.stock_quantity && (
//                                 <div className="stock-warning">
//                                   <FaExclamationTriangle />
//                                   Warning: Your selected quantity exceeds
//                                   available stock
//                                 </div>
//                               )}
//                               <div className="cart_item_mobile_actions">
//                                 <div>
//                                   <div className="quantity">
//                                     <button
//                                       className="btn btn-outline-secondary cart-border"
//                                       type="button"
//                                       onClick={() =>
//                                         handleUpdateQuantity(
//                                           item.cart_item_id,
//                                           item.quantity - 1
//                                         )
//                                       }
//                                     >
//                                       -
//                                     </button>
//                                     <input
//                                       className="text-center"
//                                       min="1"
//                                       value={item.quantity}
//                                       type="number"
//                                       readOnly
//                                     />
//                                     {/* <button
//                                       className="btn btn-outline-secondary cart-borderplus"
//                                       type="button"
//                                       onClick={() =>
//                                         handleUpdateQuantity(
//                                           item.cart_item_id,
//                                           item.quantity + 1
//                                         )
//                                       }
//                                     >
//                                       +
//                                     </button> */}
//                                     <button
//                                       className="btn btn-outline-secondary cart-borderplus"
//                                       type="button"
//                                       onClick={() =>
//                                         handleUpdateQuantity(
//                                           item.cart_item_id,
//                                           item.quantity + 1
//                                         )
//                                       }
//                                       disabled={
//                                         item.sold_out ||
//                                         item.quantity >= item.stock_quantity ||
//                                         item.actual_quantity >
//                                           item.stock_quantity
//                                       }
//                                     >
//                                       +
//                                     </button>
//                                   </div>

//                                   {showConfirmButton[item.cart_item_id] &&
//                                     !loadingUpdate[item.cart_item_id] && (
//                                       <button
//                                         className="btn btn-outline-success ml-2"
//                                         type="button"
//                                         onClick={() =>
//                                           handleConfirmUpdate(
//                                             item.cart_item_id,
//                                             item.quantity
//                                           )
//                                         }
//                                       >
//                                         Update
//                                       </button>
//                                     )}
//                                   {/* {item.actual_quantity >
//                                     item.stock_quantity && (
//                                     <div className="stock-warning">
//                                       <i className="fas fa-exclamation-triangle"></i>
//                                       Warning: Your selected quantity exceeds
//                                       available stock
//                                     </div>
//                                   )} */}
//                                   {loadingUpdate[item.cart_item_id] && (
//                                     <span
//                                       className="spinner-border spinner-border-sm ml-2"
//                                       role="status"
//                                       aria-hidden="true"
//                                     ></span>
//                                   )}
//                                 </div>
//                                 <div className="cart_item_mobile_select">
//                                   <label
//                                     className={`checkbox style-h ${
//                                       item.sold_out ? "disabled-checkbox" : ""
//                                     }`}
//                                   >
//                                     <input
//                                       type="checkbox"
//                                       checked={selectedItems.includes(
//                                         item.cart_item_id
//                                       )}
//                                       onChange={() =>
//                                         handleSelectItem(item.cart_item_id)
//                                       }
//                                       disabled={item.sold_out}
//                                     />
//                                     <div className="checkbox__checkmark"></div>
//                                     <div className="checkbox__body">
//                                       <span>Select to Order</span>
//                                     </div>
//                                   </label>
//                                 </div>
//                               </div>
//                             </div>
//                           ))
//                         ) : (
//                           <div>Your cart is empty.</div>
//                         )}
//                       </div>
//                     )}
//                   </div>

//                   <div className="cart_page_button border-top d-flex justify-content-end">
//                     <button
//                       className="btn btn-primary"
//                       type="button"
//                       onClick={handleOrderClick}
//                     >
//                       Checkout
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//       <WhatsAppChatWidget
//         phoneNumber="+919488828030"
//         companyName="Ardor Biomed"
//       />
//     </div>
//   );
// };

// export default Cart;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { deleteCartItem } from "./Apiservice";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { GoTrash } from "react-icons/go";
import WhatsAppChatWidget from "./WhatsAppChatWidget";
import { FaExclamationTriangle } from "react-icons/fa";
const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const navigate = useNavigate();
  const [availableStock, setAvailableStock] = useState({});
  const [showConfirmButton, setShowConfirmButton] = useState({});
  const [loadingUpdate, setLoadingUpdate] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, []);

  useEffect(() => {
    const fetchCartDetails = async () => {
      setLoading(true);
      setError(null);

      try {
        const userId = localStorage.getItem("userId");
        let url = `https://vishushethra.com/api/api/cart-fetch/`;
        let config = {
          headers: {
            "Content-Type": "application/json",
          },
          // withCredentials: true // Uncomment if you need credentials
        };

        // If user is logged in, fetch their cart
        if (userId) {
          url = `https://vishushethra.com/api/api/cart-fetch/${userId}/`;
        }

        const response = await axios.get(url, config);

        // Check if response has data
        if (response.data && response.data.cart) {
          setCartItems(response.data.cart);

          const availableStockMap = {};
          response.data.cart.forEach((item) => {
            availableStockMap[item.cart_item_id] = item.quantity;
          });

          setAvailableStock(availableStockMap);
        } else {
          setCartItems([]);
          setError("No cart items found.");
        }
      } catch (err) {
        console.error("Error fetching cart:", err);
        setError("Failed to load cart items. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchCartDetails();
  }, []);

  // useEffect(() => {
  //   if (cartItems.length > 0) {
  //     // Auto-select items that are in stock and have sufficient quantity
  //     const autoSelectedItems = cartItems
  //       .filter(
  //         (item) =>
  //           !item.sold_out &&
  //           item.quantity <= item.stock_quantity &&
  //           item.actual_quantity <= item.stock_quantity
  //       )
  //       .map((item) => item.cart_item_id);

  //     setSelectedItems(autoSelectedItems);
  //   }
  // }, [cartItems]);
  // Inside your Cart component
  useEffect(() => {
    if (cartItems.length > 0) {
      // Auto-select items that are in stock and have sufficient quantity
      const autoSelectedItems = cartItems
        .filter(
          (item) =>
            !item.sold_out &&
            item.quantity <= item.stock_quantity &&
            item.actual_quantity <= item.stock_quantity,
        )
        .map((item) => item.cart_item_id);

      setSelectedItems(autoSelectedItems);
    }
  }, [cartItems]);

  // Rest of the code remains same...

  const handleUpdateQuantity = (cartItemId, newQuantity) => {
    if (newQuantity < 1) return;

    const item = cartItems.find((item) => item.cart_item_id === cartItemId);

    // Check if trying to increase quantity beyond available stock
    if (newQuantity > item.stock_quantity) {
      Swal.fire({
        icon: "warning",
        title: "Insufficient Stock",
        text: `Only ${item.stock_quantity} items available in stock.`,
      });
      return;
    }

    // Update the cart item state with the new quantity
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.cart_item_id === cartItemId
          ? { ...item, quantity: newQuantity }
          : item,
      ),
    );

    // Show the confirm button after quantity change
    setShowConfirmButton((prev) => ({ ...prev, [cartItemId]: true }));
  };

  const handleConfirmUpdate = async (cartItemId, newQuantity) => {
    setLoadingUpdate((prev) => ({ ...prev, [cartItemId]: true })); // Show loading

    try {
      await axios.patch(
        `https://vishushethra.com/api/api/cart-update/${cartItemId}/`,
        { quantity: newQuantity },
      );

      setCartItems((prevItems) =>
        prevItems.map((item) =>
          item.cart_item_id === cartItemId
            ? { ...item, quantity: newQuantity }
            : item,
        ),
      );

      Swal.fire({
        icon: "success",
        title: "Updated",
        text: "Quantity and price updated successfully!",
        timer: 1500,
        showConfirmButton: false,
      }).then(() => {
        // Reload the page when "OK" is clicked
        window.location.reload();
      });

      // Hide the confirm button after success
      setShowConfirmButton((prev) => ({ ...prev, [cartItemId]: false }));
    } catch (error) {
      console.error("Error updating quantity", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update quantity.",
      });
    } finally {
      setLoadingUpdate((prev) => ({ ...prev, [cartItemId]: false })); // Reset loading
    }
  };

  const handleRemoveItem = async (cartItemId) => {
    try {
      await deleteCartItem(cartItemId);
      setCartItems((prevItems) =>
        prevItems.filter((item) => item.cart_item_id !== cartItemId),
      );
      Swal.fire({
        icon: "success",
        title: "Removed",
        text: "Item removed successfully from cart!",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error removing item from cart", error);
      setError("Failed to remove item from cart.");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to remove item from cart.",
      });
    }
  };
  const handleSelectItem = (cartItemId) => {
    setSelectedItems((prevSelected) => {
      const item = cartItems.find((item) => item.cart_item_id === cartItemId);

      if (item) {
        // Don't allow selection if item is sold out
        if (item.sold_out) {
          Swal.fire({
            icon: "warning",
            title: "Item Unavailable",
            text: "This product is currently sold out.",
          });
          return prevSelected;
        }

        // Don't allow selection if quantity exceeds stock
        if (
          item.quantity > item.stock_quantity ||
          item.actual_quantity > item.stock_quantity
        ) {
          Swal.fire({
            icon: "warning",
            title: "Insufficient Stock",
            text: `Only ${item.stock_quantity} items available in stock. Please reduce quantity.`,
          });
          return prevSelected;
        }

        // Toggle selection
        return prevSelected.includes(cartItemId)
          ? prevSelected.filter((id) => id !== cartItemId)
          : [...prevSelected, cartItemId];
      }
      return prevSelected;
    });
  };

  const handleOrderClick = () => {
    // First validate stock quantities
    const itemsWithInsufficientStock = cartItems
      .filter((item) => selectedItems.includes(item.cart_item_id))
      .filter((item) => {
        // Check if quantity exceeds stock OR actual_quantity exceeds stock
        return (
          item.quantity > item.stock_quantity ||
          item.actual_quantity > item.stock_quantity
        );
      });

    if (itemsWithInsufficientStock.length > 0) {
      const productNames = itemsWithInsufficientStock
        .map((item) => `${item.product_name} (Stock: ${item.stock_quantity})`)
        .join(", ");
      Swal.fire({
        icon: "error",
        title: "Insufficient Stock",
        html: `The following items don't have enough stock:<br><strong>${productNames}</strong><br><br>Please adjust your quantities or remove these items.`,
      });
      return;
    }

    const itemsToOrder = cartItems
      .filter((item) => selectedItems.includes(item.cart_item_id))
      .map((item) => ({
        ...item,
        updated_price: parseFloat(item.item_price * item.quantity).toFixed(2),
        offer_type: item.offer_type,
        buy_x: item.buy_x,
        get_y: item.get_y,
        discount_percentage: item.discount_percentage,
      }));

    if (itemsToOrder.length > 0) {
      Swal.fire({
        icon: "success",
        title: "Proceeding to Order",
        text: "Redirecting to order page...",
        timer: 1500,
        showConfirmButton: false,
      }).then(() => {
        navigate("/Payment", { state: { items: itemsToOrder } });
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "No items selected",
        text: "Please select at least one item to order.",
      });
    }
  };

  return (
    <div>
      <div className="banner-section  ">
        <img
          src="./assets/img/bannerbreadcrumbs.jpg"
          alt="Banner"
          className="img-fluid banner-img"
        />

        <div className="breadcrumb-container ">
          <h2> Shopping Cart</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>

              <li className="breadcrumb-item active" aria-current="page">
                Shopping Cart
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="cart_page_button container d-flex justify-content-between  align-items-center">
        <h2 className="text-center my-5">Shopping Cart</h2>
        <button
          className="btn btn-primary d-none d-md-block"
          type="button"
          onClick={handleOrderClick}
        >
          Checkout
        </button>
      </div>

      <div className="shopping_cart_area mt-5">
        <div className="container">
          <form action="#">
            <div className="cart_page_inner mb-60">
              <div className="row">
                <div className="col-12">
                  <div className="cart_page_tabel">
                    {loading ? (
                      <p>Loading...</p>
                    ) : error ? (
                      <p>{error}</p>
                    ) : (
                      <table>
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th className="text-center">Information</th>
                            <th className="text-center">Quantity</th>
                            <th className="text-center">Total</th>
                            <th className="text-center">Select to order</th>
                            <th>Remove</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cartItems.length > 0 ? (
                            [...cartItems].reverse().map((item) => (
                              // <tr key={item.product_id} className="border-top">
                              <tr
                                key={item.product_id}
                                className={`border-top ${
                                  item.sold_out ||
                                  item.stock_quantity < item.quantity
                                    ? "dim-item"
                                    : ""
                                }`}
                              >
                                <td>
                                  <div className="cart_product_thumb">
                                    <Link
                                      to={`/Productdetail/${item.product_id}`}
                                    >
                                      <img
                                        src={item.images[0]}
                                        alt={item.product_name}
                                      />
                                    </Link>
                                  </div>
                                </td>
                                <td className="cart-centermlist">
                                  <div className="cart_product_text">
                                    <h4>
                                      <Link
                                        to={`/Productdetail/${item.product_id}`}
                                        style={{ color: "black" }}
                                      >
                                        {item.product_name}{" "}
                                      </Link>
                                    </h4>

                                    {item.sold_out ? (
                                      <span className="sold-out-tag">
                                        Sold Out
                                      </span>
                                    ) : item.offer_type === "buy_x_get_y" ? (
                                      <span className="bogo-tag">
                                        Buy {item.buy_x} Get {item.get_y} Offer
                                      </span>
                                    ) : item.offer_type ===
                                        "discount_percentage" &&
                                      item.discount_percentage > 0 ? (
                                      <span className="discount-tag">
                                        {item.discount_percentage}% Off
                                      </span>
                                    ) : null}
                                    {item.actual_quantity >
                                      item.stock_quantity && (
                                      <div className="stock-warning">
                                        <FaExclamationTriangle />
                                        Warning: Your selected quantity exceeds
                                        available stock
                                      </div>
                                    )}
                                    <ul>
                                      <li>
                                        {item.size && item.size !== "" ? (
                                          <>
                                            Size: <span>{item.size}</span>
                                          </>
                                        ) : null}
                                      </li>
                                      <li>
                                        {item.option && item.option !== null ? (
                                          <>
                                            {JSON.parse(
                                              item.option.replace(/'/g, '"'),
                                            ).map((option, index) => (
                                              <div key={index}>
                                                {option.name &&
                                                  option.value && (
                                                    <>
                                                      {option.name}:{" "}
                                                      {option.value}
                                                    </>
                                                  )}
                                              </div>
                                            ))}
                                          </>
                                        ) : null}
                                      </li>
                                    </ul>
                                  </div>
                                </td>
                                <td className="product_quantity mx-2 ">
                                  <div className="cart_product_quantity d-flex align-items-center justify-content-center">
                                    <button
                                      className="btn btn-outline-secondary cart-border"
                                      type="button"
                                      onClick={() =>
                                        handleUpdateQuantity(
                                          item.cart_item_id,
                                          item.quantity - 1,
                                        )
                                      }
                                      disabled={item.sold_out}
                                    >
                                      -
                                    </button>
                                    <input
                                      className="text-center"
                                      min="1"
                                      value={item.quantity}
                                      type="number"
                                      readOnly
                                      style={{
                                        width: "50px",
                                      }}
                                      disabled={item.sold_out}
                                    />

                                    <button
                                      className="btn btn-outline-secondary cart-borderplus"
                                      type="button"
                                      onClick={() =>
                                        handleUpdateQuantity(
                                          item.cart_item_id,
                                          item.quantity + 1,
                                        )
                                      }
                                      disabled={
                                        item.sold_out ||
                                        item.quantity >= item.stock_quantity ||
                                        item.actual_quantity >
                                          item.stock_quantity
                                      }
                                    >
                                      +
                                    </button>

                                    {showConfirmButton[item.cart_item_id] &&
                                      !loadingUpdate[item.cart_item_id] && (
                                        <button
                                          className="btn btn-outline-success ml-2"
                                          type="button"
                                          onClick={() =>
                                            handleConfirmUpdate(
                                              item.cart_item_id,
                                              item.quantity,
                                            )
                                          }
                                        >
                                          Update
                                        </button>
                                      )}

                                    {loadingUpdate[item.cart_item_id] && (
                                      <span
                                        className="spinner-border spinner-border-sm ml-2"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    )}
                                  </div>
                                </td>

                                <td>
                                  <div className="cart_product_price">
                                    {loadingUpdate[item.cart_item_id] ? (
                                      <span>
                                        <span
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        <span
                                          style={{
                                            fontSize: "13px",
                                            marginLeft: "5px",
                                          }}
                                        >
                                          Updating...
                                        </span>
                                      </span>
                                    ) : (
                                      <span>
                                        ₹
                                        {parseFloat(
                                          item.item_price,
                                        ).toLocaleString("en-IN", {
                                          minimumFractionDigits: 2,
                                        })}{" "}
                                        <span style={{ fontSize: "13px" }}>
                                          INR
                                        </span>
                                      </span>
                                    )}
                                  </div>
                                </td>

                                {/* <td className="cart-center">
                                  <div className="checkboxes__row">
                                    <label className="checkbox style-h">
                                      <input
                                        type="checkbox"
                                        checked={selectedItems.includes(
                                          item.cart_item_id
                                        )}
                                        onChange={() =>
                                          handleSelectItem(item.cart_item_id)
                                        }
                                      />
                                      <div className="checkbox__checkmark"></div>
                                      <div className="checkbox__body">
                                        <span>Select to Order</span>
                                      </div>
                                    </label>
                                  </div>
                                </td> */}
                                <td className="cart-center">
                                  <div className="checkboxes__row">
                                    <label className="checkbox style-h">
                                      <input
                                        type="checkbox"
                                        checked={selectedItems.includes(
                                          item.cart_item_id,
                                        )}
                                        onChange={() =>
                                          handleSelectItem(item.cart_item_id)
                                        }
                                        disabled={
                                          item.sold_out ||
                                          item.quantity > item.stock_quantity ||
                                          item.actual_quantity >
                                            item.stock_quantity
                                        }
                                      />
                                      <div className="checkbox__checkmark"></div>
                                      <div className="checkbox__body">
                                        <span>Select to Order</span>
                                      </div>
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <div className="cart_product_remove">
                                    <button
                                      className="btn btn-danger px-4"
                                      type="button"
                                      onClick={() =>
                                        handleRemoveItem(item.cart_item_id)
                                      }
                                    >
                                      <GoTrash
                                        style={{
                                          fontSize: "20px",
                                          fontWeight: "900",
                                        }}
                                      />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7">Your cart is empty.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="cart_page_mobiletabel">
                    {loading ? (
                      <p>Loading...</p>
                    ) : error ? (
                      <p>{error}</p>
                    ) : (
                      <div>
                        {/* Mobile Responsive Design */}
                        {cartItems.length > 0 ? (
                          [...cartItems].reverse().map((item) => (
                            // <div
                            //   key={item.product_id}
                            //   className="cart_item_mobile"
                            // >
                            <div
                              key={item.product_id}
                              className={`cart_item_mobile ${
                                item.sold_out ||
                                item.stock_quantity < item.quantity
                                  ? "dim-item"
                                  : ""
                              }`}
                            >
                              <div className="cart_item_mobile_info">
                                <div className="cart_product_thumb">
                                  <Link
                                    to={`/Productdetail/${item.product_id}`}
                                  >
                                    <img
                                      src={item.images[0]}
                                      alt={item.product_name}
                                    />
                                  </Link>
                                </div>
                                <div>
                                  <div className="cart_item_mobile_price">
                                    <span>
                                      ₹
                                      {parseFloat(
                                        item.item_price,
                                      ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                      })}{" "}
                                      <span style={{ fontSize: "13px" }}>
                                        INR
                                      </span>
                                    </span>
                                  </div>
                                  <h4>
                                    {" "}
                                    <Link
                                      to={`/Productdetail/${item.product_id}`}
                                      style={{ color: "black" }}
                                    >
                                      {item.product_name}
                                    </Link>
                                  </h4>
                                  {/* {item.sold_out ? (
                                    <span className="sold-out-tag">
                                      Sold Out
                                    </span>
                                  ) : (
                                    item.is_bogo && (
                                      <span className="bogo-tag">
                                        Buy 1 Get 1 Offer
                                      </span>
                                    )
                                  )} */}
                                  {/* {item.sold_out ? (
                                    <span className="sold-out-tag">
                                      Sold Out
                                    </span>
                                  ) : (
                                    item.offer_type === "bogo" && (
                                      <span className="bogo-tag">
                                        Buy {item.offer_details.buy_quantity}{" "}
                                        Get {item.offer_details.get_quantity}{" "}
                                        Offer
                                      </span>
                                    )
                                  )} */}
                                  {item.sold_out ? (
                                    <span className="sold-out-tag">
                                      Sold Out
                                    </span>
                                  ) : item.offer_type === "buy_x_get_y" ? (
                                    <span className="bogo-tag">
                                      Buy {item.buy_x} Get {item.get_y} Offer
                                    </span>
                                  ) : item.offer_type ===
                                      "discount_percentage" &&
                                    item.discount_percentage > 0 ? (
                                    <span className="discount-tag">
                                      {item.discount_percentage}% Off
                                    </span>
                                  ) : null}
                                  <ul style={{ paddingLeft: "0px" }}>
                                    {item.size && item.size !== "" ? (
                                      <>
                                        Size: <span>{item.size}</span>
                                      </>
                                    ) : null}
                                    <li style={{ paddingLeft: "0px" }}>
                                      {item.option && item.option !== null ? (
                                        <>
                                          {JSON.parse(
                                            item.option.replace(/'/g, '"'),
                                          ).map((option, index) => (
                                            <div key={index}>
                                              {option.name && option.value && (
                                                <>
                                                  {option.name}: {option.value}
                                                </>
                                              )}
                                            </div>
                                          ))}
                                        </>
                                      ) : null}
                                    </li>
                                  </ul>
                                </div>
                                <div>
                                  <div className="cart_item_mobile_remove">
                                    <button
                                      className="btn btn-danger"
                                      type="button"
                                      onClick={() =>
                                        handleRemoveItem(item.cart_item_id)
                                      }
                                    >
                                      <GoTrash />
                                    </button>
                                  </div>
                                </div>
                              </div>
                              {item.actual_quantity > item.stock_quantity && (
                                <div className="stock-warning">
                                  <FaExclamationTriangle />
                                  Warning: Your selected quantity exceeds
                                  available stock
                                </div>
                              )}
                              <div className="cart_item_mobile_actions">
                                <div>
                                  <div className="quantity">
                                    <button
                                      className="btn btn-outline-secondary cart-border"
                                      type="button"
                                      onClick={() =>
                                        handleUpdateQuantity(
                                          item.cart_item_id,
                                          item.quantity - 1,
                                        )
                                      }
                                    >
                                      -
                                    </button>
                                    <input
                                      className="text-center"
                                      min="1"
                                      value={item.quantity}
                                      type="number"
                                      readOnly
                                    />
                                    {/* <button
                                      className="btn btn-outline-secondary cart-borderplus"
                                      type="button"
                                      onClick={() =>
                                        handleUpdateQuantity(
                                          item.cart_item_id,
                                          item.quantity + 1
                                        )
                                      }
                                    >
                                      +
                                    </button> */}
                                    <button
                                      className="btn btn-outline-secondary cart-borderplus"
                                      type="button"
                                      onClick={() =>
                                        handleUpdateQuantity(
                                          item.cart_item_id,
                                          item.quantity + 1,
                                        )
                                      }
                                      disabled={
                                        item.sold_out ||
                                        item.quantity >= item.stock_quantity ||
                                        item.actual_quantity >
                                          item.stock_quantity
                                      }
                                    >
                                      +
                                    </button>
                                  </div>

                                  {showConfirmButton[item.cart_item_id] &&
                                    !loadingUpdate[item.cart_item_id] && (
                                      <button
                                        className="btn btn-outline-success ml-2"
                                        type="button"
                                        onClick={() =>
                                          handleConfirmUpdate(
                                            item.cart_item_id,
                                            item.quantity,
                                          )
                                        }
                                      >
                                        Update
                                      </button>
                                    )}
                                  {/* {item.actual_quantity >
                                    item.stock_quantity && (
                                    <div className="stock-warning">
                                      <i className="fas fa-exclamation-triangle"></i>
                                      Warning: Your selected quantity exceeds
                                      available stock
                                    </div>
                                  )} */}
                                  {loadingUpdate[item.cart_item_id] && (
                                    <span
                                      className="spinner-border spinner-border-sm ml-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  )}
                                </div>
                                {/* <div className="cart_item_mobile_select">
                                  <label
                                    className={`checkbox style-h ${
                                      item.sold_out ? "disabled-checkbox" : ""
                                    }`}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedItems.includes(
                                        item.cart_item_id
                                      )}
                                      onChange={() =>
                                        handleSelectItem(item.cart_item_id)
                                      }
                                      disabled={item.sold_out}
                                    />
                                    <div className="checkbox__checkmark"></div>
                                    <div className="checkbox__body">
                                      <span>Select to Order</span>
                                    </div>
                                  </label>
                                </div> */}
                                <div className="cart_item_mobile_select">
                                  <label
                                    className={`checkbox style-h ${
                                      item.sold_out ||
                                      item.quantity > item.stock_quantity ||
                                      item.actual_quantity > item.stock_quantity
                                        ? "disabled-checkbox"
                                        : ""
                                    }`}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedItems.includes(
                                        item.cart_item_id,
                                      )}
                                      onChange={() =>
                                        handleSelectItem(item.cart_item_id)
                                      }
                                      disabled={
                                        item.sold_out ||
                                        item.quantity > item.stock_quantity ||
                                        item.actual_quantity >
                                          item.stock_quantity
                                      }
                                    />
                                    <div className="checkbox__checkmark"></div>
                                    <div className="checkbox__body">
                                      <span>Select to Order</span>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div>Your cart is empty.</div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="cart_page_button border-top d-flex justify-content-end">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={handleOrderClick}
                    >
                      Checkout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <WhatsAppChatWidget
        phoneNumber="+918939711577"
        companyName="VishuShethra Industries"
      />
    </div>
  );
};

export default Cart;
